import React, { useEffect, useCallback } from "react"; // React ve gerekli hook'ları import et
import { useTranslation } from "react-i18next";
import * as MyStorage from "../helpers/myStorage"; // MyStorage'daki yeni fonksiyonları kullanacağız
import { getServiceList } from "../services/service.service"; // API servisi
import { Navigate, useNavigate } from "react-router-dom";
import config from "../config";

// process.env'den gelen değeri sabit olarak tanımla
// const connectionCode = process.env.REACT_APP_CONNECTION_CODE;
const connectionCode = config().CONNECTION_CODE;

const NodeModal = () => {
  const { t } = useTranslation(); // Çoklu dil desteği için hook
  const navigate = useNavigate(); // Yönlendirme için hook

  // --- Yardımcı Fonksiyonlar (useCallback ile memoize edildi) ---

  // Dashboard sayfasına yönlendirme fonksiyonu
  const openPage = useCallback(() => {
    return <Navigate to="/" replace={true} />;
  }, [navigate]); // navigate değiştiğinde yeniden oluştur

  // Node seçimi ve servis listesini çekme fonksiyonu
  const selectNode = useCallback(async (node) => {
    if (!node || !node.code) {
      console.error("selectNode: Geçersiz node objesi veya node kodu eksik.");
      // Hata durumunda kullanıcıya bilgi verilebilir
      return;
    }

    MyStorage.AppCache.setSelectedConnectionNode(node); // Seçilen node'u kaydet

    try {
      const res = await getServiceList({
        connectionCode: connectionCode,
        // Artık AppCache üzerinden doğrudan node.code alabiliriz
        nodeCode: node.code,
      });
      MyStorage.AppCache.setServicelist(res);
      openPage(); // Servisler yüklendikten veya hata oluşsa bile sayfayı aç
    } catch (err) {
      console.error("Servis listesi alınırken hata oluştu:", err);
      // Hata durumunda kullanıcıya hata mesajı gösterebilir veya yönlendirme yapabilir
    }

  }, [openPage]); // openPage fonksiyonuna bağımlı

  // --- useEffect Hook'u ---

  useEffect(() => {
    const selectedConnection = MyStorage.AppCache.getSelectedConnection();
    const selectedConnectionNode = MyStorage.AppCache.getSelectedConnectionNode();

    // Bağlantı bilgileri ve node listesi mevcutsa kontrol et
    if (selectedConnection && Array.isArray(selectedConnection.nodeList)) {
      if (selectedConnection.nodeList.length === 1 && selectedConnectionNode === null) {
        // Tek bir node varsa ve henüz seçilmemişse, otomatik seç
        selectNode(selectedConnection.nodeList[0]);
      } else {
        // Birden fazla node varsa veya zaten node seçilmişse doğrudan sayfayı aç
        openPage();
      }
    } else {
      // Bağlantı bilgisi veya node listesi yoksa
      console.warn("NodeModal: Seçili bağlantı bilgisi veya node listesi bulunamadı. Dashboard'a yönlendiriliyor.");
      openPage(); // Doğrudan dashboard'a yönlendir
    }
  }, [selectNode, openPage]); // Bağımlılıkları doğru şekilde ayarla

  // --- Render Kısmı ---

  // Node listesini çek
  const nodes = MyStorage.AppCache.getSelectedConnection().nodeList;

  // Node listesi yoksa veya boşsa modalı gösterme veya bir yükleme/hata mesajı göster
  if (!nodes || nodes.length === 0) {
    // Burada bir yükleme spinner'ı veya hata mesajı gösterebilirsiniz.
    // Örneğin: return <div>Yükleniyor...</div>;
    // Ya da doğrudan dashboard'a yönlendirilebilirsiniz, ancak bu zaten useEffect'te ele alındı.
    return null; // Modalın gösterilmesini engelle
  }

  return (
    <div
      tabIndex="-1"
      className="top-0 left-0 z-50 w-full h-full p-4 overflow-x-hidden justify-center flex items-center overflow-y-auto md:inset-0 absolute"
    >
      <div className="relative w-full max-w-2xl max-h-full">
        <div className="relative bg-white rounded-lg shadow-lg border-4 border-indigo-600 dark:bg-gray-900">
          <div className="w-full p-5 flex justify-center text-lg font-semibold border-b border-indigo-600">
            <h1>{t("Select Node")}</h1>
          </div>
          <div className="p-6 space-y-6 w-full flex flex-col items-center justify-center">
            {nodes.map((node) => (
              <div
                className="text-base font-medium flex justify-center hover:bg-indigo-600 hover:text-white w-full py-2 cursor-pointer"
                key={node.code} // Node'un benzersiz kodu varsa onu key olarak kullan
                onClick={() => selectNode(node)}
              >
                {node.name} / {node.code}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NodeModal;